import SettingItem from "./SettingItem";

export default SettingItem;